<template>
  <div class="labeled-select-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <SelectInput
      ref="selectInput"
      :value="value"
      :options="options"
      :placeholder="placeholder"
      :type="type"
      :autocomplete-mask="autocompleteMask"
      :search-threshold="searchThreshold"
      :is-disabled="isDisabled"
      :label-key="labelKey"
      :value-key="valueKey"
      :show-icon="showIcon"
      :icon-color="iconColor"
      :filter-mode="filterMode"
      :hide-dropdown-when-empty="hideDropdownWhenEmpty"
      :empty-text="emptyText"
      :dropdown-position="dropdownPosition"
      :select-first-by-default="selectFirstByDefault"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <template #option="{ option }">
        <slot name="option" :option="option" />
      </template>
    </SelectInput>
  </div>
</template>

<script>
import SelectInput from '../select';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      enum: ['select', 'autocomplete'],
      default: 'select',
    },
    autocompleteMask: {
      type: [String, Function, Boolean],
      default: null
    },
    searchThreshold: {
      type: Number,
      default: 0
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    iconColor: {
      type: String,
      default: '#71717A',
    },
    filterMode: {
      type: String,
      default: 'local',
      validator: (value) => ['local', 'remote'].includes(value),
    },
    hideDropdownWhenEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'No options available'
    },
    dropdownPosition: {
      type: String,
      default: 'auto',
      validator: (value) => ['auto', 'top', 'bottom'].includes(value)
    },
    selectFirstByDefault: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId: `select-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, SelectInput },
  computed: {
    getSelect() {
      return this.$refs.selectInput;
    },
  },
  methods: {
    generateRandomId,
  },
};
</script>
